import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const assetsDataManagerObjectClassesEntryPoint = createEntryPoint({
	root: JSResourceForUserVisible(() => {
		if (!__SERVER__) {
			return import(
				/* webpackChunkName: "async-assets-data-manager-object-classes-page", jiraSpaEntry: "async-assets-data-manager-object-classes-page" */ './src'
			);
		}
		// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
		return Promise.resolve(() => null) as unknown as Promise<typeof import('./src/')>;
	}),
	getPreloadProps: () => ({}),
});
